var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("option-field", {
    attrs: {
      "display-name": _vm.Resources.Layout.ThemeSelectorLabel,
      "has-transparent-bg": "",
      options: _vm.themeOptions,
      layout: "condensed",
      "data-qa": "footer-theme-dropdown",
    },
    scopedSlots: _vm._u([
      {
        key: "label",
        fn: function () {
          return [
            _c("label", { staticClass: "gfu-field__label _tc--light _mb-1" }, [
              _c("span", { attrs: { "data-qa": "field-label-text" } }, [
                _vm._v(_vm._s(_vm.Resources.Layout.ThemeSelectorLabel)),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v
      },
      expression: "value",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }